import './index.scss'
$("header .nav ul li").eq(5).addClass("active"); 

$(".right ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".answer").slideToggle();
})
$(".faq-nav ul li").eq(0).addClass("active");
$(".right ul").eq(0).addClass("active");
$(".faq-nav ul li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".right ul").eq(index).addClass("active").siblings().removeClass("active");
})